import React from 'react'
import Icon, { TopBarLogo } from 'components/Icons'

const GoBack = ({ history }) => {
  if (!history) return null

  return (
    <button className='btn' style={{ minWidth: '124px' }} onClick={history.goBack}>
      <Icon
        type='arrow'
        direction='left'
        color='white'
        style={{
          fontSize: '20px',
          marginBottom: '-5px'
        }}
      /> Go back
    </button>
  )
}

const NotEnabledPage = ({ permission, history }) =>
  <div className='no-access-wrapper'>
    <NotEnabledComponent permission={permission} history={history} />
  </div>

const NotEnabledComponent = ({ history }) =>
  <div className='no-access'>
    <div className='content-box'>
      <TopBarLogo style={{ height: '124px', width: '124px' }} />
      <h1
        style={{
          lineHeight: 'unset',
          paddingTop: '30px',
          fontSize: '36px',
          fontWeight: 'bold'
        }}
      >
        Not Enabled
      </h1>
      <p>This feature in not enabled for your location.</p>
      <GoBack history={history} />
    </div>
  </div>

export default NotEnabledPage

export {
  NotEnabledComponent,
  NotEnabledPage
}
